<template>
  <div class="declareview" ref="previewDom" style="padding-bottom: 50px">
    <div class="a4" style="min-height: 490px;">
      <h1 style="font-size: 30px; font-weight: 600;text-align: center">
         优质工程创优策划登记表
      </h1>
      <p style="font-size: 22px; line-height: 40px;text-align:center">项目简况</p>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">工程名称</div>
          <div class="box justify-center" style="width:600px;height:50px">{{ alldata.Enterpriseoverview.msg1 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">申报单位(盖公章)</div>
          <div class="box justify-center" style="width:600px;height:50px">{{ alldata.Enterpriseoverview.msg2 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">工程类别</div>
          <div class="box justify-center" style="width:220px;height:50px">{{ alldata.Enterpriseoverview.msg3 }}</div>
          <div class="box justify-center" style="width:160px;height:50px">建设规模</div>
          <div class="box justify-center" style="width:222px;height:50px">{{ alldata.Enterpriseoverview.msg4 }}</div>
      </div>
      <div class="th">
          <div class="box justify-center" style="width:120px;height:50px">开工时间</div>
          <div class="box justify-center" style="width:220px;height:50px;">
              {{ alldata.Enterpriseoverview.msg5 }}
          </div>
          <div class="box justify-center" style="width:160px;height:50px">计划竣工时间</div>
          <div class="box justify-center" style="width:220px;height:50px;">
            {{alldata.Enterpriseoverview.msg6}}
          </div>
      </div>
        <div class="th">
            <div class="box justify-center" style="width:120px;height:50px">建设地点</div>
            <div class="box justify-center" style="width:600px;height:50px">{{ alldata.Enterpriseoverview.msg7 }}</div>
        </div>
        <div class="th">
            <div class="box justify-center" style="width:120px;height:50px">最终质量目标</div>
            <div class="box justify-center" style="width:220px;height:50px">{{ alldata.Enterpriseoverview.msg8 }}</div>
            <div class="box justify-center" style="width:160px;height:50px">申报联系人</div>
            <div class="box justify-center" style="width:222px;height:50px">{{ alldata.Enterpriseoverview.msg9 }}</div>
        </div>
        <div class="th">
            <div class="box justify-center" style="width:120px;height:50px">联系电话</div>
            <div class="box justify-center" style="width:220px;height:50px">{{ alldata.Enterpriseoverview.msg10 }}</div>
            <div class="box justify-center" style="width:160px;height:50px">邮箱</div>
            <div class="box justify-center" style="width:222px;height:50px">{{ alldata.Enterpriseoverview.msg11 }}</div>
        </div>
    </div>
      <div class="botview">
          <div class="a3">
              <div class="th" style="padding: 0 60px">
                  <div class="box justify-center" style="width: 340px; height: 50px">
                      附件
                  </div>
                  <div class="box justify-center" style="width: 382px; height: 50px">
                      <a target="_blank" v-if="alldata.filelist.length>0" :href="'http://test-dev.welamp.cn'+alldata.filelist[0].response.data.url">
                          {{alldata.filelist[0].response.data.originalName}}
                      </a>
                  </div>
              </div>
              <div class="th" style="padding: 0 60px">
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import "../word/pdfview.less";
export default {
  props: {
    alldata: {
      type: Object,
    },
    time:String,
    title:String
  },
  data() {
    return {
      mdStyle: {},
      pdfandimg: [],
      loadingTask: "",
      numPages: null,
      url: "",
    };
  },
  mounted() {
    this.$emit("previewDom", this.$refs.previewDom); //整页DOM上传至父组件
    console.log("declare", this.time)
    this.convertDateFromString(this.time)
  },
  methods: {
    fn() {},
    panduan(msg,oldmsg){
        return msg == oldmsg?'☑'+oldmsg:'□'+oldmsg
    },
     convertDateFromString(dateString) {
      if (dateString) {
      var arr1 = dateString.split(" ");
      var sdate = arr1[0].split('-');
      // var date = new Date(sdate[0], sdate[1]-1, sdate[2]);
      // console.log(sdate,date.toLocaleString())
      return sdate;
    }
}
  },
};
</script>

<style lang="less" scoped>
.flex-direction{
    display: flex;
    flex-direction: column;
}
</style>
